import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CartasAmonestacionService } from './../../../../services/cartas-amonestacion/cartas-amonestacion.service';
import { DocumentosService } from 'src/app/pages/services/documentos.service';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { SolicitudesDocumentosService } from 'src/app/pages/services/solicitudes/solicitudesdocumentos.service';
import { getRoleFromToken } from 'src/app/shared/components/helpers/role.helpers';

@Component({
  selector: 'app-modal-mostrar',
  templateUrl: './modal-mostrar.component.html',
  styleUrls: ['./modal-mostrar.component.css'],
})
export class ModalMostrarComponent implements OnInit {
  isAuditor = getRoleFromToken() === 'AUDITOR';
  @Input() idTrabajador: any;

  constructor(
    private cartaservice: CartasAmonestacionService,
    private documentoService: DocumentosService,
    private solicitudDocumentoService: SolicitudesDocumentosService,
    private alert: AlertHelper
  ) {}

  loading: boolean = false;
  loadingData: boolean = false; 
  displayedColumns = ['rut', 'fecha', 'grado', 'motivo', 'acciones'];
  dataSource: any;
  cartas: any;
  info_documento: any;

  // 🚀 Inicializa el componente cargando las cartas de amonestación del trabajador ✨
  ngOnInit(): void {
    this.TraerCartas();
  }

  // 🚀 Descarga un archivo de carta de amonestación y lo abre en una nueva ventana ✨
  Descargar(id: any) {
    this.cartaservice.traerArchivoCarta(id).subscribe((res) => {
      this.info_documento = res.data[0];
      window.open(`${environment.API}/cartas/` + res.data[0].ruta);
    });
  }

  // 🚀 Obtiene las cartas de amonestación del trabajador y formatea la información ✨
  async TraerCartas() {
    this.loadingData = true; 
    const resCarta = await this.cartaservice.traerCartaPorTrabajadorAsync(this.idTrabajador);
    this.cartas = resCarta.data;
    const cartaSoure = [];

    for (const carta of this.cartas) {
      if (carta.Grado == 1) carta.Grado = 'Menor';
      if (carta.Grado == 2) carta.Grado = 'Medio';
      if (carta.Grado == 3) carta.Grado = 'Grave';

      const resDoc = await this.documentoService.traerDocCartaAsync(carta.id);
      if (resDoc.success) {
        const documento = resDoc.data;
        const resSol = await this.solicitudDocumentoService.TraerPorDocumento(documento[0].cp_documento);
        carta.pendienteSolicitud = resSol ? resSol.data : false;
      } else {
        carta.pendienteSolicitud = false;
      }

      cartaSoure.push(carta);
    }

    this.dataSource = cartaSoure;
    this.loadingData = false; 
  }

  // 🚀 Elimina una carta de amonestación y solicita su eliminación en el sistema ✨
  async Borrar(id: number) {
    this.loading = true;
    if (confirm('¿Seguro que desea eliminar la amonestación?')) {
      const res = await this.documentoService.eliminarDocumentoAsync(id, 'AMONESTACION');
      if (res.success) {
        this.alert.success_small('Se creó la solicitud para eliminar el documento.');
        await this.TraerCartas();
      } else {
        this.alert.error_small(res.msg);
      }
    }
    this.loading = false;
  }
}
